import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useState } from 'react';
export var useInput = function useInput(_ref) {
  var initialState = _ref.initialState,
    errorText = _ref.errorText,
    invalidHandler = _ref.invalidHandler;
  var _useState = useState(initialState),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isValid = _useState6[0],
    setIsValid = _useState6[1];
  var onChange = useCallback(function (event) {
    setValue(event.target.value);
    setErrorMessage('');
  }, []);
  var onBlur = useCallback(function (event) {
    var isValidValue = invalidHandler(event.target.value);
    var inValidMessage = isValidValue ? '' : errorText;
    setErrorMessage(inValidMessage);
    setIsValid(inValidMessage.length === 0);
  }, [errorText, invalidHandler]);
  return {
    value: value,
    errorMessage: errorMessage,
    isValid: isValid,
    onChange: onChange,
    onBlur: onBlur,
    setErrorMessage: setErrorMessage
  };
};